import { ExternalLinkAction, TxnLinkAction } from 'src/utils/notifications';
import { getUrlForTx } from 'src/utils/explorer';
import Link from 'src/components/primitives/Link/Link';

const NotificationLink = ({
	linkData,
}: {
	linkData: TxnLinkAction | ExternalLinkAction;
}) => {
	if (linkData.type === 'link') {
		return (
			<Link variant="primary" href={linkData.href} openInNewTab>
				{linkData.label ?? 'More Info'}
			</Link>
		);
	}

	if (typeof linkData.txnSig === 'string') {
		return <NotificationTxnLinkWithIcon txnSig={linkData.txnSig} />;
	}

	return (
		<div className="flex flex-col gap-y-sm">
			{linkData.txnSig.map((txnSig, index) => (
				<NotificationTxnLinkWithIcon
					key={txnSig}
					txnSig={txnSig}
					label={`View Transaction #${index + 1}`}
				/>
			))}
		</div>
	);
};

const NotificationTxnLinkWithIcon = ({
	txnSig,
	label,
}: {
	txnSig: string;
	label?: string;
}) => {
	return (
		<Link variant="primary" href={getUrlForTx(txnSig)} openInNewTab>
			{label ?? 'View Transaction'}
		</Link>
	);
};

export default NotificationLink;
